(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('strToNum', function() {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function(value) {
                        return '' + value;
                    });
                    ngModel.$formatters.push(function(value) {
                        return parseFloat(value);
                    });
                }
            };
        })
        .directive('formField', formField);

    /* @ngInject */
    function formField($sce) {
        var directive = {
            templateUrl: 'form-field.tpl',
            bindToController: true,
            controller: formFieldCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            require: ['?field', '?fieldKey', '?fieldModel', '?parentPath', '?ngModel'],
            scope: {
                field: '=',
                fidx: '@',
                fieldKey: '@',
                fieldModel: '=',
                parentPath: '@',
                topModel: '=',
                asAccordion: '=',
                activeAccordionItem: '='
            }
        };
        return directive;

        function link(scope, element, attrs, field, fieldKey, fieldModel, parentPath, ngModel) {
            if (angular.isArray(scope.vm.fieldModel) && !scope.vm.fieldModel.length) {
                delete scope.vm.fieldModel;
            }

            scope.vm.fieldPath = scope.vm.parentPath + ((scope.vm.parentPath.length > 0) ? ',' : '') + scope.vm.fieldKey;
            scope.vm.fieldId = scope.vm.fieldPath.replace(/,/g, '--');


            if(
                scope.vm.field.type == 'multigroup' &&
                scope.vm.field.fields &&
                typeof scope.vm.activeGroup == 'undefined'
            ) {
                scope.vm.activeGroup = 0;
            }

            if(scope.vm.field.type == 'pickup-location') {
                scope.vm.locationTabSwitch = 'map';
            }

            if(scope.vm.asAccordion) {
                // do not collaps first item of accordion
                scope.vm.collapsed = (scope.vm.fidx === "0" ? true : false);
            }

            if(
                scope.vm.field.type == 'group' &&
                scope.vm.field.fields &&
                scope.vm.field.repetitive == true &&
                typeof scope.vm.repetitiveFields == 'undefined'
            ) {
                scope.vm.repetitiveFields = [];

                //scope.vm.repetitiveFields.push(scope.vm.field.fields);

                if(typeof scope.vm.fieldModel !== 'undefined') {
                    angular.forEach(scope.vm.fieldModel, function(repeate, idx) {
                        scope.vm.repetitiveFields.push(scope.vm.field.fields);
                    });
                } else {
                    scope.vm.repetitiveFields.push(scope.vm.field.fields);
                }

            }

            if(angular.isUndefined(scope.vm.fieldModel) || angular.isUndefined(scope.vm.fieldModel.value) || !scope.vm.fieldModel.value) {
                if(typeof scope.vm.field.default === 'undefined') {
                    if(angular.isUndefined(scope.vm.fieldModel)) {
                        scope.vm.fieldModel = (scope.vm.field.repetitive == true) ? [] : {};
                    }
                } else {
                    if(scope.vm.field.type === 'checkbox') {
                        scope.vm.fieldModel = {};
                        angular.forEach(scope.vm.field.choices, function(choice, idx) {
                            scope.vm.fieldModel[choice.value] = (scope.vm.field.default.indexOf(choice.value) >= 0);
                        });
                    } else if (scope.vm.field.default) {
                        scope.vm.fieldModel = {
                            value: scope.vm.field.default
                        };
                    }
                }
            }

            if (scope.vm.field.type == 'html') {
                if (typeof scope.vm.fieldModel.value == 'string') {
                    scope.vm.fieldModel.value = $sce.trustAsHtml(scope.vm.fieldModel.value);
                }
            }


            scope.vm.addRow = function() {
                if(scope.vm.field.max && !isNaN(scope.vm.field.max)) {
                    if (scope.vm.repetitiveFields.length == scope.vm.field.max) {
                        return;
                    }
                }
                scope.vm.repetitiveFields.push(scope.vm.field.fields);
            };

            scope.vm.repeaterMax = function() {
                if(scope.vm.field.max && !isNaN(scope.vm.field.max)) {
                    if (scope.vm.repetitiveFields.length >= scope.vm.field.max) {
                        return false;
                    }
                }
                return true;
            };

            scope.vm.removeRow = function(index) {
                scope.vm.repetitiveFields.splice(index, 1);
                scope.vm.fieldModel.splice(index, 1);
            };

            scope.vm.prevGroup = function() {
                // var currentGroup = scope.vm.subGroups.indexOf(scope.vm.activeGroup);
                // if(currentGroup > 0) {
                //     scope.vm.activeGroup = scope.vm.subGroups[currentGroup - 1];
                // }
                if(scope.vm.activeGroup > 0) { scope.vm.activeGroup--; }
            };

            scope.vm.nextGroup = function() {
                // var currentGroup = scope.vm.subGroups.indexOf(scope.vm.activeGroup);
                // if(currentGroup < scope.vm.subGroups.length - 1) {
                //     scope.vm.activeGroup = scope.vm.subGroups[currentGroup + 1];
                // }
                if(scope.vm.activeGroup < scope.vm.field.fields.length - 1) { scope.vm.activeGroup++; }
            };

            scope.vm.getIndex = function() {
                var me = angular.element('[field-key="' + scope.vm.fieldKey + '"]');
                return me.parent().children(':visible').index(me) + 1 ;
            };
            /*
            var consoleStyles = [
                'font-weight: 600',
                'padding: 1.75em 0 .25em 0',
                'margin-bottom: .75em',
                'border-bottom: 2px dotted #0cf'
            ].join(';');
            console.log('%cformField.link / single > ' + scope.$id, consoleStyles);
            console.log(scope.vm.field);
            console.log('%cfieldId%c: ' + scope.vm.fieldId, 'font-weight: 600', 'font-weight: 400');
            console.log('%cfieldKey%c: ' + scope.vm.fieldKey, 'font-weight: 600', 'font-weight: 400');
            console.log('%cfieldPath%c: ' + scope.vm.fieldPath, 'font-weight: 600', 'font-weight: 400');
            console.log('%cparentPath%c: ' + scope.vm.parentPath, 'font-weight: 600', 'font-weight: 400');
            */

            if (angular.isDefined(scope.vm.field['remote-hook']) && (scope.vm.field['remote-hook'])) {
                if (angular.isDefined(scope.vm.field.choices)) {
                    var p = {type: '', value: ''};
                    if (scope.vm.field['remote-hook'].indexOf('|')) {
                        var s = scope.vm.field['remote-hook'].split('|');
                        p.type =  s[0];
                        p.value =  s[1];
                    } else {
                        p.type =  scope.vm.field['remote-hook'];
                    }

                    scope.getRemoteChoices(p);
                } else {
                    scope.getRemoteContent({
                        type: scope.vm.field['remote-hook'],
                        value: ''
                    });
                    delete scope.vm.fieldModel ;
                }
            }
            if (scope.vm.field.type == 'post-link') {
                scope.getRemoteChoices({
                    type: 'post',
                    value: scope.vm.field['post-types'][0].value
                });
            }
            if (scope.vm.field.type == 'term-link') {
                scope.getRemoteChoices({
                    type: 'taxonomy',
                    value: scope.vm.field.taxonomy
                });

                if (angular.isDefined(scope.vm.field['link-to']) && scope.vm.field['link-to']) {
                    scope.vm.fieldModel['link-to'] = scope.vm.field.taxonomy;
                } else {
                    delete(scope.vm.fieldModel['link-to']);
                }

            }

            // scope.vm.isExpanded = scope.vm.activeAccordionItem == scope.vm.fieldKey;
            scope.vm.field.expanded = scope.vm.activeAccordionItem == scope.vm.fieldKey;
            if (scope.vm.field.type == 'cart-pie') {
                scope.vm.fieldModel.tooltips.forEach(function(e, i) {
                    if (e.text) {
                        if (!scope.$root.tooltips) {
                            scope.$root.tooltips = {};
                        }
                        scope.$root.tooltips[scope.vm.parentPath.replace(',', '-') + '-tt' + (i + 1)] = e.text.replaceAll('<p>', '').replaceAll('</p>', '<br>');
                    }

                });

                scope.vm.fieldModel.description = scope.vm.fieldModel.description.replace(/<a.+?>.+?<\/a>/g, function(m) {
                    var tooltipID = '';
                    m = m.replace(/href=".*?#tt(\d)"/, function(hm, tt) {
                        tooltipID = 'tt' + tt;
                        return hm.replace('#tt' + tt, '');
                    });
                    if (tooltipID) {
                        m = m.replace('<a', '<a class="tt ' + scope.vm.parentPath.replace(',', '-') + '-' + tooltipID + '"');
                    }
                    return m;
                });
            }
            // scope.vm.field.expanded = false;
            // console.log(scope.$parent.$parent.$parent.$parent);
        }
    }

    /* @ngInject */
    function formFieldCtrl($scope,$http,$sce) {

        $scope.getRemoteChoices = function(params) {

            // + knee-top realization :)

            var adata = {
                action: 'lbs-action',
                method: 'get_remote_choices',
                module: 'cfd',
                params: params
            };
            $http.post(ajaxurl, adata).then(function(response) {
                $scope.vm.field.choices = response.data.payload;
            });

            // - knee-top realization

        };
        $scope.getRemoteContent = function(params) {

            // + knee-top realization :)
            var adata = {
                action: 'lbs-action',
                method: 'get_remote_content',
                module: 'cfd',
                params: params
            };
            $http.post(ajaxurl, adata).then(function(response) {
                $scope.vm.viewContent = $sce.trustAsHtml(response.data.payload);
            });

            // - knee-top realization

        };
        $scope.onClick = function() {
            $scope.$eval($scope.vm.field['on-click']);
        };

        $scope.wysiwygCreated = function(editor) {
            if (typeof window.quills == 'undefined') {
                window.quills = [];
            }
            window.quills.push(editor);
        };

        $scope.range = function(min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };

        $scope.accordionTabShow = function() {
            return $scope.vm.field.expanded;
        };

        $scope.accordionToggle = function(e) {
            e.stopPropagation();
            if ($scope.vm.field.classes.indexOf('disabled') != -1) {
                return;
            }
            $scope.vm.field.expanded = !$scope.vm.field.expanded;
            $scope.$root.$broadcast("accordion-tab", $scope.vm.fieldKey);
            if ($scope.$root.rsp.apn.chk) {
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('.form-field[field-key="' + $scope.vm.fieldKey + '"] .content').parent().offset().top - 185
                    }, 100);
                }, 100);
            } else {
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('.form-field[field-key="' + $scope.vm.fieldKey + '"] .content').parent().offset().top - 84
                    }, 100);
                }, 100);
            }
        };

        $scope.wearwolf = function(id) {  // pie quantity select ->  number
            if ($scope.$root.project_has_opt("layoutCS") && ($scope.vm.fieldModel.value == 11)) {
                $scope.vm.fieldModel.ww = true;
                $scope.vm.fieldModel.value = '';
            }
            setTimeout(function() {
                angular.element('#' + id + '-input').focus();
            }, 100);
        };



        if ($scope.$root.project_has_opt("layoutCS")) { // remove && update mobile w/o sidebar
            $scope.$watch('vm.field', function(field) {
                $scope.vm.quantity = 0;
                $scope.vm.new_quantity = 0;
                if (field.type == 'cart-pie') {
                    $scope.$on('sidebar-pies', function(_, v) {
                        var id = $scope.vm.fieldModel.id;
                        if (v[id]) {
                            $scope.vm.quantity = v[id].value;
                            $scope.vm.new_quantity = v[id].value;
                            $scope.vm.editQuantity = false;
                        }
                    });


                    $scope.saveQuantity = function() {
                        $scope.$emit("pie-set-quantity", {id: $scope.vm.fieldModel.id, quantity: $scope.vm.new_quantity ? parseInt($scope.vm.new_quantity) : 0});
                    };
                }
            });

        }

        $scope.numberChange = function(e) {
            if (e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        };

    }

})();